import styled from 'styled-components';
import { black } from 'utils/style/colors';

export const MentionList = styled('div')`
  max-height: calc(100vh - 300px);
  overflow: auto;
`;
export const MentionItem = styled('div')`
  display: flex;
  align-items: center;
  padding: 10px 0px;
  &:not(:last-child) {
    border-bottom: 1px solid lightgray;
  }
`;
export const MentionBody = styled('div')`
  max-width: 300px;
  white-space: pre-wrap;
  padding: 0px 10px;
  cursor: pointer;
  flex-grow: 1;
`;
export const MentionDate = styled('div')`
  width: 100px;
  font-size: 0.85rem;
  height: 100%;
  margin-top: 10px;
  text-align: end;
  color: ${black};
`;
export const MentionListBody = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const MentionListHeader = styled('div')`
  display: flex;
  justify-content: space-between;
`;
